import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["styles"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { PureComponent } from 'react';
import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import { styleReducerNoOp } from '../../../theme';
import Item from '../Item';
import { jsx as ___EmotionJSX } from "@emotion/core";
var gridSize = gridSizeFn();

var modifyStyles = function modifyStyles(defaultStyles) {
  return _objectSpread(_objectSpread({}, defaultStyles), {}, {
    itemBase: _objectSpread(_objectSpread({}, defaultStyles.itemBase), {}, {
      height: gridSize * 6,
      paddingBottom: 0,
      paddingLeft: gridSize / 2 - 2,
      // Offset by 2px to account for border of avatar
      paddingRight: gridSize / 2,
      paddingTop: 0
    }),
    beforeWrapper: _objectSpread(_objectSpread({}, defaultStyles.beforeWrapper), {}, {
      marginRight: gridSize - 2 // Offset by 2px to account for border of avatar

    }),
    afterWrapper: _objectSpread(_objectSpread({}, defaultStyles.afterWrapper), {}, {
      marginLeft: gridSize
    }),
    textWrapper: _objectSpread(_objectSpread({}, defaultStyles.textWrapper), {}, {
      fontWeight: 600
    })
  });
};

var ContainerHeader = /*#__PURE__*/function (_PureComponent) {
  _inherits(ContainerHeader, _PureComponent);

  var _super = _createSuper(ContainerHeader);

  function ContainerHeader() {
    _classCallCheck(this, ContainerHeader);

    return _super.apply(this, arguments);
  }

  _createClass(ContainerHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          styleReducer = _this$props.styles,
          props = _objectWithoutProperties(_this$props, _excluded); // We modify the Item styles ourselves, then allow the consumer to modify
      // these if they want to.


      var patchedStyles = function patchedStyles(defaultStyles, state) {
        return styleReducer(modifyStyles(defaultStyles), state);
      };

      return ___EmotionJSX(Item, _extends({}, props, {
        styles: patchedStyles,
        spacing: "default"
      }));
    }
  }]);

  return ContainerHeader;
}(PureComponent);

_defineProperty(ContainerHeader, "defaultProps", {
  styles: styleReducerNoOp,
  isSelected: false,
  text: ''
});

export { ContainerHeader as default };